interface NavIconProps {
  color?: string
}

// 마켓 아이콘 — 피그마: _market (bar chart)
export const IconNavMarket = ({ color = '#8f9194' }: NavIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="11" width="4" height="9" rx="0.5" stroke={color} strokeWidth="1.5" />
    <rect x="10" y="6" width="4" height="14" rx="0.5" stroke={color} strokeWidth="1.5" />
    <rect x="17" y="3" width="4" height="17" rx="0.5" stroke={color} strokeWidth="1.5" />
  </svg>
)
